import script from "./DefaultHeaderInPE.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultHeaderInPE.vue?vue&type=script&setup=true&lang=js"

import "./DefaultHeaderInPE.vue?vue&type=style&index=0&id=d396f914&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d396f914"]])

export default __exports__